import { epgDatesModel, isSameDate, type EpgDateEx } from '$/epg/dates'
import { createEvent, createStore, sample } from 'effector'

export const autoSetActive = createEvent()

export const setActive = createEvent<EpgDateEx | null>()

export const $active = createStore<EpgDateEx | null>(null) //
  .on(setActive, (current, date) => {
    return current == null || date != null ? date : current
  })

// initially selected by url date
export const $initial = createStore<EpgDateEx | null>(null)

// select first date if there is no active date yet
sample({
  clock: autoSetActive,
  source: {
    active: $active,
    week: epgDatesModel.$week,
  },
  filter: ({ active, week }) => active == null && week.length > 0,
  fn: ({ week }) => {
    const today = week.find((item) => item.isToday)
    return today
  },
  target: setActive,
})

// set initial date on autoSetActive
sample({
  clock: autoSetActive,
  source: {
    active: $active,
    initial: $initial,
    week: epgDatesModel.$week,
  },
  filter: ({ active, initial, week }) =>
    active != null && initial == null && week.find(isSameDate(active)) == null,
  fn: ({ active }) => active,
  target: $initial,
})

// set today date as active after day change
sample({
  clock: epgDatesModel.$today,
  source: {
    active: $active,
    week: epgDatesModel.$week,
  },
  // if today was updated, and active day disappeared from the week
  filter: ({ active, week }) =>
    active != null && week.find(isSameDate(active)) == null,
  // -> select new today day from the week
  fn: ({ week }) => {
    const today = week.find((item) => item.isToday)
    return today
  },
  target: setActive,
})
